import { Instagram, Facebook, Twitter, Heart } from "lucide-react";
import { BRAND } from "@/constants/brand";

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

const LINKS = [
  { label: "Mission", id: "mission" },
  { label: "Programs", id: "programs" },
  { label: "About", id: "about" },
  { label: "Get Involved", id: "get-involved" },
  { label: "Contact", id: "contact" },
];

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#08090b] text-white border-t border-white/10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3 mb-5">
              <img
                src={BRAND.logo}
                alt="DADication logo"
                className="h-16 w-16 object-contain"
              />
              <span className="font-display uppercase text-2xl tracking-wide">
                DADication
              </span>
            </div>
            <p className="text-white/50 leading-relaxed max-w-sm">
              Redefining modern fatherhood through resources, mentorship, wellness,
              and community. Real dads deserve love, support, and the opportunity
              to thrive.
            </p>
            <div className="flex items-center gap-3 mt-6">
              {[
                { icon: Instagram, href: BRAND.social.instagram, label: "Instagram" },
                { icon: Facebook, href: BRAND.social.facebook, label: "Facebook" },
                { icon: Twitter, href: BRAND.social.twitter, label: "Twitter" },
              ].map((s) => (
                <a
                  key={s.label}
                  data-testid={`footer-social-${s.label.toLowerCase()}`}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={s.label}
                  className="h-11 w-11 flex items-center justify-center border border-white/15 hover:bg-[#e2562a] hover:border-[#e2562a] transition-colors"
                >
                  <s.icon className="h-5 w-5" />
                </a>
              ))}
            </div>
            <a
              data-testid="footer-instagram-handle"
              href={BRAND.social.instagram}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 mt-5 text-white/60 hover:text-[#e2562a] transition-colors"
            >
              <Instagram className="h-4 w-4" />
              <span className="text-sm font-medium">@wearedadication</span>
            </a>
          </div>

          <div className="md:col-span-3 md:col-start-7">
            <h4 className="font-display uppercase text-lg tracking-wide mb-5">
              Explore
            </h4>
            <ul className="space-y-3">
              {LINKS.map((l) => (
                <li key={l.id}>
                  <button
                    data-testid={`footer-link-${l.id}`}
                    onClick={() => scrollTo(l.id)}
                    className="text-white/50 hover:text-[#e2562a] transition-colors text-sm uppercase tracking-wider"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-display uppercase text-lg tracking-wide mb-5">
              Support the movement
            </h4>
            <p className="text-white/50 mb-5 text-sm leading-relaxed">
              Stronger fathers help create stronger families and stronger
              communities.
            </p>
            <button
              data-testid="footer-donate-btn"
              onClick={() => scrollTo("get-involved")}
              className="inline-flex items-center gap-2 bg-[#e2562a] hover:bg-[#c4451d] text-white px-6 py-3 font-bold uppercase tracking-wider transition-all hover:-translate-y-0.5"
            >
              <Heart className="h-4 w-4" strokeWidth={2.5} /> Donate
            </button>
          </div>
        </div>

        <div className="border-t border-white/10 mt-16 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-white/40 text-sm">
            © {new Date().getFullYear()} DADication. All rights reserved.
          </p>
          <p className="text-white/40 text-sm uppercase tracking-wider">
            Built with dedication for fathers everywhere.
          </p>
        </div>
      </div>
    </footer>
  );
};
